import React, { useEffect, useRef } from 'react';
import { useRecoilValue, useResetRecoilState } from 'recoil';

import { notificationState } from 'state/atoms';
import { Alert } from 'components/Alert';
import { Container } from 'components/layout';

const Notification = () => {
  const { show, text, type, timeout } = useRecoilValue(notificationState);
  const resetNotification = useResetRecoilState(notificationState);
  const resetTimeout = useRef(null);

  useEffect(() => {
    if (timeout) {
      resetTimeout.current = setTimeout(resetNotification, timeout);
    } else if (resetTimeout.current) {
      clearTimeout(resetTimeout.current);
    }
  }, [resetNotification, timeout]);

  return (
    <Alert show={show} type={type} onClose={resetNotification}>
      <Container>{text}</Container>
    </Alert>
  );
};

export { Notification };
